import axiosInstance from './axios';
import PaginationData from 'types/models/PaginationData';
import TwitterConfig from 'types/models/TwitterConfig';
import joinURLParams from 'utils/joinUrlParams';

export const getTwitterConfigs = async (
  page?: number,
  searchTerm?: string,
): Promise<PaginationData<TwitterConfig> | null> => {
  try {
    const url = joinURLParams({ page: page ?? 1, searchTerm }, 'twitter-configs');
    const { data: paginationData } = await axiosInstance({
      method: 'get',
      url,
    });
    return {
      currentPage: paginationData.current_page,
      data: parseConfigs(paginationData.data),
      perPage: paginationData.per_page,
      total: paginationData.total,
    };
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const storeTwitterConfig = async (twitterConfig: TwitterConfig): Promise<TwitterConfig | null> => {
  try {
    const { data } = await axiosInstance({
      method: 'post',
      url: 'twitter-configs',
      data: twitterConfig,
    });
    return parseConfig(data);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const updateTwitterConfig = async (twitterConfig: TwitterConfig): Promise<TwitterConfig | null> => {
  try {
    const { data } = await axiosInstance({
      method: 'put',
      url: `twitter-configs/${twitterConfig.id}`,
      data: twitterConfig,
    });
    return parseConfig(data);
  } catch (error) {
    console.log(error);
    return null;
  }
};

const parseConfigs = (twitterConfigs: any): TwitterConfig[] => {
  return twitterConfigs.map((twitterConfig: any): TwitterConfig => parseConfig(twitterConfig));
};

const parseConfig = (twitterConfig: any): TwitterConfig => {
  return {
    id: twitterConfig.id,
    searchType: twitterConfig.search_type_id,
    value: twitterConfig.value,
  };
};
